<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">
        <i class="fas fa-file icon"></i>
        Documentos
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <router-link :to="{ name: 'administrativeHome' }">
                <span>
                  <i class="fas fa-home icon"></i>
                  inicio
                </span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'cellarsAdministrator' }">
                <span>
                  <i class="fas fa-boxes icon"></i>
                  Bodegas
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{ name: 'documentsAdministrator' }">
                <span>
                  <i class="fas fa-file icon"></i>
                  Documentos
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div slot="folders">
        <ListDirectory :chargeDocumentList="chargeDocumentList"></ListDirectory>
      </div>

      <div slot="contenido">
        <div class="box">
          <b-button
            type="is-primary is-small"
            icon-left="plus"
            rounded
            @click="openCreate()"
            >Ingresar Documento</b-button
          >
          <b-button
            :disabled="checkedRows.length == 0"
            type="is-success is-small"
            icon-left="folder"
            rounded
            @click="addDocumentDirectory()"
            style="margin-left: 1%"
            >Trasladar documento a carpeta</b-button
          >
          <b-button 
            icon-left="download" 
            class="button is-primary is-small" 
            style="margin-left: 1%" 
            type="button" 
            rounded 
            @click="openGenerateReport"
          >Descargar reporte</b-button>
          <b-table
            type="is-primary"
            :data.sync="listDocument.data"
            :loading="loading"            
            :is-fullwidth="true"
            checkable
            :checkbox-position="'right'"
            :checked-rows.sync="checkedRows"
            detailed
            narrowed
            paginated
            backend-pagination
            :total="listDocument.total"
            :per-page="listDocument.per_page"
            :current-page.sync="currentPage"
            @page-change="onPageChange"
          >
            <template slot-scope="props">
              <b-table-column field="favorite">
                <b-icon
                  v-if="props.row.favorite == '1'"
                  type="is-warning"
                  icon="star"
                  size="is-small"
                >
                </b-icon>
              </b-table-column>
              <b-table-column field="number" label="N° Documento" searchable>{{
                props.row.number
              }}</b-table-column>
              <b-table-column field="date_document" label="Fecha" searchable>
                <span class="tag is-success">
                  {{ formatDate(props.row.date_document)}}
                </span>
              </b-table-column>
              <b-table-column
                field="document_type.name"
                label="Tipo de Documento"
                searchable
                >{{ props.row.document_type?props.row.document_type.name: 'Sin Tipo' }}</b-table-column
              >
              <b-table-column field="cellar.name" label="Bodega" searchable>{{
                props.row.cellar.name
              }}</b-table-column>

              <b-table-column label="Acciones" width="200px">
                <div class="buttons">
                  <b-button
                    type="is-primary is-small"
                    icon-left="edit"
                    @click="openModalEdit(props.row)"
                  ></b-button>
                  <b-button
                    type="is-primary is-small"
                    icon-left="search"
                    @click="openViewPdf(props.row.id)"
                  ></b-button>
                  <b-button
                    type="is-danger is-small"
                    icon-left="trash"
                    @click="eliminatedDocument(props.row.id)"
                  ></b-button>
                  <a :href="props.row.file" target="_blank">
                    <b-button
                      type="is-primary is-small"
                      icon-left="download"
                    ></b-button>
                  </a>
                </div>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <article class="media">
                <div class="media-content">
                  <div class="content">
                    <p><b>Descripción:</b> {{ props.row.description }}</p>
                  </div>
                </div>
              </article>
            </template>
          </b-table>
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../../template/PlantillaContenido";
import CreateDocument from "../../../components/administrative/document/CreateDocument";
import ViewPdf from "../../../components/administrative/document/ViewPdf";
import ListDirectory from "../../../components/administrative/directory/ListDirectory";
import addDocumentDirectory from "../../../components/general/directory/AddDocumentDirectory";
import EditDocument from "../../../components/administrative/document/EditDocument.vue";
import { DocumentService } from '../../../services/models/document';
import GenerateReport from "../../../components/general/GenerateReport"
import {eventBus} from "./../../../main";
import moment from "moment";

export default {
  components: {
    PlantillaContenido,
    ListDirectory,
  },
  data() {
    return {
      user_type_id: null,
      listDocument: [],
      checkedRows: [],
      loading: false,
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 15,
    };
  },
  mounted: function () {
    this.chargeDocumentList();
  },
  methods: {
    formatDate(date){
      return moment(date).format('YYYY-MM-DD')
    },
    openModalEdit(document){            
      this.$buefy.modal.open({
        parent: this,
        component: EditDocument,
        fullScreen: true,
        props: {
          documentProp:document,
          chargeDocumentList:this.chargeDocumentList
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onPageChange(page) {
      this.chargeDocumentList(page);      
    },
    openGenerateReport() {
      this.$buefy.modal.open({
        parent: this,
        component: GenerateReport,
        props: {
          cellar_id: this.$route.params.id,
          serviceReport: DocumentService.downloadReport
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    openCreate() {
      this.$buefy.modal.open({
        parent: this,
        component: CreateDocument,
        fullScreen: true,
        props: {
          chargeDocumentList: this.chargeDocumentList,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    openViewPdf(id) {
      this.$buefy.modal.open({
        parent: this,
        component: ViewPdf,
        fullScreen: true,
        props: {
          id: id,
          chargeDocumentList: this.chargeDocumentList,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async chargeDocumentList(page = 1) {
      this.loading = true;
      const {
        data: documents,
      } = await DocumentService.getDocumentsFindByUserCellar(
        this.$route.params.id,page
      );
      this.listDocument = documents;
      this.currentPage=documents.current_page,
      this.perPage= documents.per_page,
      // this.listDocument = await getDocumentsFindByUserCellar(this.$http,this.$route.params.id);
      this.loading = false;
    },
    async addDocumentDirectory() {
      this.$buefy.modal.open({
        parent: this,
        component: addDocumentDirectory,
        props: {
          checkedRows: this.checkedRows,
          chargeDocumentList: this.chargeDocumentList,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async eliminatedDocument(id) {
      this.$buefy.dialog.confirm({
        title: "¿Desea eliminar este documento?",
        message:
          "Una vez eliminado, el documento sera movido a <b>Documento Eliminados</b>",
        confirmText: "Eliminar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.loading = true;
          await DocumentService.remove(id);
          //  await deleteDocument(this.$http,id);
          this.chargeDocumentList();
          eventBus.$emit('loadDirectories');
          this.$buefy.notification.open({
            message: `El documento fue eliminado con exito!`,
            type: "is-success",
          });
          this.loading = false;
        },
      });
    },
  },
};
</script>

